import { getMaxZIndex } from '@utils/dom';
import { isEnabled } from 'FeatureToggle.util';
import Ajax from '@utils/ajax';
import { convertHTMLEntitiesInString } from 'String.util';

import 'add-item.mod';
import autosize from 'autosize.lib';

import { avatarFallback } from './avatar-fallback';
import { initializeManageNav } from './manage-nav';
import './site-footer';

import { renderCompanyData, Modals } from './company-data';

import { renderIdentityVerification } from './identity-verification';

import { renderBenchmarkingStatusUpdate } from './benchmarking-status-update';

import { disabledForPermsTest } from 'permissions.mod';
import { sanitize } from '@bamboohr/utils/lib/dom';

/**
 *	bamboo is the app object literal
 *
 *	place all globally accessible objects inside the bamboo object.
 **/
window.BambooHR = window.BambooHR || {};

window.bhrChosenOptions = window.bhrChosenOptions || {
	allow_single_deselect: true,
	disable_search_threshold: 8,
};

if (typeof console === 'undefined' || typeof console.log === 'undefined') {
	console = {};
	console.log = function () {};
}

/**
 * App Prefix
 *
 * Use this javascript variable for loading pages outside the normal app. For example in self onboarding, the prefix would
 * be "self_onboarding/" to call various pages.
 *
 * NOTE: You may have to make your own pages and update existing javascript to use this variable. An example of the javascript can
 * be found in files_tab.js
 *
 * @type String
 */
export const appPrefix = window.appPrefix || '';

export const formChanged = false;

// Used for switching between jade and non-jade options
const DATEPICKER_JADE_MAP = {
	buttonClasses: isEnabled('jade') ? 'fab-TextInput__button' : 'btn btnIcon',
	buttonImage: isEnabled('jade') ? '' : '/images/color-branded-icons/calendar-input-icon.svg',
	buttonText: isEnabled('jade')
		? `<span class="fab-TextInput__buttonIcon">
		<ba-icon name="fab-calendar-15x16">
	</span>`
		: '',
	triggerClasses: isEnabled('jade') ? 'fab-TextInput__button' : 'ui-datepicker-trigger btn btnIcon',
};

export const HSHQ_DATEPICKER_OPTIONS = {
	yearRange: '-100:+20',
	highlightWeek: true,
	duration: 0,
	showAnim: false,
	changeFirstDay: false,
	changeMonth: true,
	changeYear: true,
	showOn: 'button',
	buttonImage: DATEPICKER_JADE_MAP.buttonImage,
	buttonImageOnly: false,
	buttonText: DATEPICKER_JADE_MAP.buttonText,
	showOtherMonths: true,
	onClose(date, ui) {
		setTimeout(function () {
			ui.input.next('button').addClass(DATEPICKER_JADE_MAP.buttonClasses).find('img').addClass('branded-icon').end().end();
			ui.input.trigger('blur.mask');
		}, 1);
		//check if datefield has value and hide placeholder if so
		if (jQuery.placeholder) {
			jQuery.placeholder.check(ui.input);
		}
		// isNotDateMask: when a user clicks off of the datepicker it will run the onClose event.
		// the date that we are given is the date format
		// For some reason datepicker interprets a date mask as 'today'. We don't want that.
		const isNotDateMask = date.toLowerCase().indexOf('yy') < 0;
		if ($(this).hasClass('js-toDate') && isNotDateMask) {
			$(`.js-fromDate[data-calendar-id=${$(this).attr('data-calendar-id')}]`).datepicker('option', 'maxDate', date);
		} else if ($(this).hasClass('js-fromDate') && isNotDateMask) {
			$(`.js-toDate[data-calendar-id=${$(this).attr('data-calendar-id')}]`).datepicker('option', 'minDate', date);
		}
	},
};

if (typeof window.GLOBAL_DATEPICKER_MASK !== 'undefined') {
	HSHQ_DATEPICKER_OPTIONS.dateFormat = window.GLOBAL_DATEPICKER_MASK;
}

$.datepicker.setDefaults($.datepicker.regional[$('html').attr('lang')]);
//now that we have set the translations, replace the day names for the header in the dialog with the 3 letter version.
$.datepicker.setDefaults({
	dayNames: moment.weekdays(),
	dayNamesShort: moment.weekdaysShort(),
	dayNamesMin: moment.weekdaysMin(),
	monthNames: moment.months(),
	monthNamesShort: moment.monthsShort('-MMM-'),
});

$.datepicker.parseDate = function parseDate(format, value) {
	const mom = moment(value, moment.convert.jQuery(format));
	return mom.isValid() ? mom.toDate() : null;
};

$.datepicker.formatDate = function formatDate(format, value) {
	const mom = moment(value);
	return mom.isValid() ? mom.format(moment.convert.jQuery(format)) : null;
};

export { disabledForPermsTest };

initializeManageNav();

$(document).ready(function () {
	/**
		FYI, if you follow the correct structure, a dropdown list item with a child list(<ul>)
		should not close the dropdown on click
	**/
	if (!window.BASE_DROP_DOWN_MENU) {
		window.BASE_DROP_DOWN_MENU = true;
		$(document).on('click', '.dropdown-menu', function (e) {
			/* JN - removed .top-nav-dd and moved below for hover instead of click */ const $this = $(this);
			const $target = $(e.target);
			/**
			 * if there are list items that should not close the list on click,
			 * use the .js-no-close class on the li element
			 */
			const $noClose = $target.closest('li.js-no-close');
			const inlineButtonSelector = '> [class*="inline-bicon-"]';
			e.stopPropagation();

			if ($this.hasClass('disabled') || ($target.is('a') && $target.next().is('ul'))) {
				return;
			}

			$('body > .down-list.js-popout').remove();

			$(`.dropdown-menu .btn.active, .dropdown-menu ${inlineButtonSelector}, .js-downListToggle`)
				.not($this.find(`.btn.active, ${inlineButtonSelector}`))
				.removeClass('active');
			if (!$noClose.length) {
				$this.find(`.btn, ${inlineButtonSelector}`).toggleClass('active');
			}

			let $downlist = $('.down-list', this);

			if ($downlist.hasClass('js-popout') && !$downlist.is(':visible')) {
				$downlist.css('opacity', 0).show();

				const boundingRect = $downlist[0].getBoundingClientRect();

				let { scrollX } = window;
				let { scrollY } = window;

				if (typeof scrollX === 'undefined') {
					scrollX = window.pageXOffset;
					scrollY = window.pageYOffset;
				}

				$downlist.hide().css('opacity', '');

				$downlist = $downlist
					.clone(true)
					.css({
						left: Math.round(boundingRect.left + scrollX),
						top: Math.round(boundingRect.top + scrollY),
					})
					.appendTo(document.body);
			}

			if (!$noClose.length) {
				$downlist.toggle();
			}

			if ($downlist.is('.right-edge')) {
				$downlist.css({
					position: 'absolute',
					left: `-${$downlist.outerWidth(true) - $this.outerWidth(true)}px`,
				});
			}
		});
	}

	$(document).on('click', function (event) {
		if (!event.target.id || event.target.id !== 'search-input') {
			$('.down-list,#employeeTabMenu').hide();
		}
		$('.dropdown-menu .btn.active, .dropdown-menu > [class*="inline-bicon-"], .js-downListToggle').removeClass('active');
		$('body > .down-list.js-popout').remove();
	});

	/* manage nav on hover */
	$('.top-nav-dd').on('click', '.js-downListToggle', function (e) {
		const $toggle = $(this);
		$toggle.parent('#manage-nav').find('.down-list').hide();

		const $dropdownList = $toggle.next('.down-list').removeClass('edge').toggle(0);

		const rightOffset = $(window).outerWidth() - $dropdownList[0].getBoundingClientRect().right;
		if (rightOffset - 20 < 0) {
			$dropdownList.addClass('edge');
		} else {
			$dropdownList.removeClass('edge');
		}

		$(this).toggleClass('active');

		return false;
	});

	let avatarTimer;

	$('.top-nav-dd').on('mouseenter', function (e) {
		if ($(this).children('.down-list').is(':visible')) {
			clearTimeout(avatarTimer);
		}
	});

	$('.top-nav-dd').on('mouseleave', function () {
		/* fixes issue if clicked instead of hovered */ $(this).children('.js-downListToggle').removeClass('active');

		if ($(this).children('.down-list').is(':visible')) {
			const sub = $(this);
			avatarTimer = setTimeout(function () {
				$(sub).children('.down-list').hide();
			}, 250);
		}
	});

	// fix for target="_blank", you can also use rel="noopener noreferrer"
	$("a[rel='external']").click(function () {
		const newWindow = window.open($(this).attr('href'), '_blank', 'noopener,noreferrer');
		if (newWindow) {
			newWindow.opener = null;
		}
		return false;
	});

	// Enable global search if class=globalsearch
	const preload = new Image();
	preload.src = '/images/loader3.gif';
	if ($('#quicksearchquery.globalsearch').length) {
		//added to only use if exists on page
		if (typeof window.bhrLiveSearchVars === 'undefined') {
			window.bhrLiveSearchVars = {};
		}

		const $globalsearch = $('#quicksearchquery.globalsearch');
		const $globalsearchForm = $('#quicksearchform');
		let globalsearchSubmit = true;

		$globalsearch.bhrLiveSearch(window.bhrLiveSearchVars);
		$globalsearch.on('bhrLiveSearch:emptyResults', function () {
			globalsearchSubmit = false;
		});
		$globalsearch.on('bhrLiveSearch:nonEmptyResults', function () {
			globalsearchSubmit = true;
		});
		$globalsearchForm.submit(function () {
			return globalsearchSubmit;
		});
	}

	//If not global search, then use the old quick search
	const opts = {
		delay: 0,
		cacheLength: 1,
		selectFirst: true,
		matchSubset: false,
		max: 20,
		formatItem: activeIndicator,
	};

	$('body').on('click', '.disabledForPermsTest', function (event) {
		return disabledForPermsTest(event);
	});

	$('.hovered').hover(
		function () {
			$(this).addClass('hovers');
		},
		function () {
			$(this).removeClass('hovers');
		}
	);

	// Global keyboard shortcuts
	$(document).bind('keypress.bhrSearchShortcut', function (e) {
		if (!BambooHR.Utils.hasFocusedElement(document) && !document.querySelectorAll('.js-simplemodal-container').length) {
			switch (e.which) {
				case 115: // 's'
					$('#quicksearchquery, #quicksearchcustomers').focus();
					e.preventDefault();
					return false;
			}
		}
	});

	$('#helpLinks #supportLink11').click(function (e) {
		e.preventDefault();
		ajaxModalDialog(
			$.__('Submit a Support Request'),
			$(this).attr('href'),
			$.__('Submit'),
			function () {
				window.modalSubmit(
					function () {
						//refresh the page.
						closeModalReloadPage();
					},
					function () {
						return true;
					}
				);
			},
			undefined,
			{
				modal: true,
				cancel_message: $.__('Cancel'),
				open_callback() {},
			}
		);
	});
	/*end header nav js*/

	/* Try to override these attributes, if we can't we will just use the defaults */
	try {
		window.AbstractChosen.default_multiple_text = $.__('Select Some Options');
		window.AbstractChosen.default_single_text = $.__('-- Select --');
		window.AbstractChosen.default_no_result_text = $.__('No results match');
	} catch (error) {
		if (window.Rollbar && window.Rollbar.debug) {
			window.Rollbar.debug('Unable to add new attributes to AbstractChosen');
		} else {
			console.error('Unable to add new attributes to AbstractChosen');
		}
	}

	window.requestAnimationFrame(function () {
		adjustStickyFooter(true);
	});
});

function closeModalReloadPage() {
	document.location.reload(true);
	closeModalDialog();
}

/**
 * Adjust the sticky footer
 *
 * Make sticky footer not sticky when window doesn't scroll (AKA bring it up to the content of the page with position: static instead of position: fixed)
 *
 * @param {boolean} onload Boolean to check if the function call is on page load or window resize
 *
 * @returns {void}
 */
function adjustStickyFooter(onload) {
	const footer = $('footer:not(.SiteFooter)');

	if (footer.hasClass('fixedFooter') && !footer.hasClass('empFixedFooter') && !footer.hasClass('stickySmallFooter')) {
		$('body').css('height', 'auto'); // Fix short form footer position.

		// find the height of the content of the footer, if it exists, make that the offset, otherwise set to 0
		let offset = footer.find('#inside-footer').height() || 0;
		//If on page load, add the offset for the footer height as the spacer is currently hidden (the spacer will take up the space in the body when shown)
		if (onload) {
			offset = footer.outerHeight();
		}

		if (document.body.offsetHeight + offset < window.innerHeight) {
			if (!footer.hasClass('staticFooter')) {
				footer.addClass('staticFooter');
				$('#inside-content .BhrForms').addClass('staticFooter').removeClass('stickyFooter');
				$('.fixedFooter--spacer').hide();
			}
		} else if (!footer.hasClass('stickyFooter')) {
			footer.removeClass('staticFooter');
			$('#inside-content .BhrForms').removeClass('staticFooter').addClass('stickyFooter');
			$('.fixedFooter--spacer').show();
		}

		$('footer').css('display', 'block');
	}

	window.requestAnimationFrame(function () {
		adjustStickyFooter();
	});
}

export function showCustomFieldsMessage(event) {
	const selectedValue = event?.target?.value;
	const customFieldBuilderMessage = document.getElementsByClassName('customFieldBuilderSupport');
	if (selectedValue === 'Custom Fields' && isEnabled('CORE_TOGGLE_CUSTOM_FIELD_BUILDER')) {
		customFieldBuilderMessage.item(0).classList.remove('hidden');
	} else {
		customFieldBuilderMessage.item(0).classList.add('hidden');
	}
}

export function showHelpWidget(admin = false) {
	window.BambooHR.Modal.setState({
		isLoading: true,
		isOpen: true,
		title: $.__('Submit a Support Request'),
		primaryActionText: $.__('Submit'),
		primaryAction() {
			window.BambooHR.Modal.setState(
				{
					isProcessing: true,
				},
				true
			);

			const helpForm = document.querySelector(`#fabricModalContent form#help-form`);
			const action = helpForm.getAttribute('action');
			const formData = new FormData(helpForm);

			formData.append('url', window.location.toString());

			const data = Ajax.prepareData(formData, Ajax.prepareDataTypes.URL_SEARCH_PARAMS).toString();

			Ajax.post(action, data).then(() => {
				window.BambooHR.Modal.setState({});
				window.setMessage($.__(`Message Sent`), 'success');
			});
		},
	});

	Ajax.get('/ajax/dialog/feedback.php', {
		admin: !!admin || null,
	})
		.then(({ data: html }) => {
			window.BambooHR.Modal.setState(
				{
					dangerousContent: html,
					isLoading: false,
				},
				true
			);
		})
		.then(() => {
			const categorySelect = document.querySelector('select#category');
			if (categorySelect && isEnabled('CORE_TOGGLE_CUSTOM_FIELD_BUILDER')) {
				categorySelect.onchange = function (event) {
					showCustomFieldsMessage(event);
				};
				const openCustomFieldBuilderButton = document.getElementById('customFieldBuilderSupport-message--button');
				openCustomFieldBuilderButton.onclick = function () {
					window.location.href = '/settings/custom_fields';
				};
			}
		})
		.catch(() => {
			window.BambooHR.Modal.setState({});
			window.setMessage($.__('Oops. Something went wrong. Please try again later.'), 'error');
		});
}

function closeExistingThickbox() {
	$('#TB_imageOff, #TB_closeWindowButton').unbind('click');
	$('#TB_window,#TB_load,#TB_overlay,#TB_HideSelect').trigger('unload').unbind().remove();
	document.onkeydown = '';
	document.onkeyup = '';
}

renderBenchmarkingStatusUpdate();

renderIdentityVerification();

renderCompanyData();

export function clearDemoData() {
	renderCompanyData({
		defaultModal: Modals.CLEAR_DEMO_DATA_MODAL,
		onDefaultModalClose: () => renderCompanyData({ defaultModal: undefined }),
	});
}

export function addLinks(name, list) {
	for (let i = 0; i < list.length; ++i) {
		$('<li><a></a></li>').find('a').attr('href', list[i].url).text(list[i].name).end().appendTo('#context-menu');
	}
}

export function xmlEntities(str) {
	let ret = '';
	str = `${str}`;
	for (let i = 0; i < str.length; ++i) {
		const c = str.substr(i, 1);
		switch (c) {
			case '"':
				ret += '&quot;';
				break;
			case '<':
				ret += '&lt;';
				break;
			case '>':
				ret += '&gt;';
				break;
			case '&':
				ret += '&amp;';
				break;
			case "'":
				ret += '&#x27;';
				break;
			default:
				ret += c;
				break;
		}
	}
	return ret;
}

export function js(str) {
	let ret = '';
	for (let i = 0; i < str.length; ++i) {
		const c = str.substr(i, 1);
		switch (c) {
			case '\n':
				ret += '\\n';
				break;
			case '\r':
				ret += '\\r';
				break;
			case '<':
			case '>':
			case '&':
			case "'":
			case '"':
				ret += `\\x${c.charCodeAt(0).toString(16)}`;
				break;
			default:
				ret += c;
				break;
		}
	}
	return ret;
}
export function activeIndicator(row, pos, num, search) {
	const name = sanitize(convertHTMLEntitiesInString(row[0]));
	const ret = `<span class="qs_status icon ${row[2]}"></span><span class="qs_status ${row[2]}">${name}</span>`;
	return ret;
}
export function qsWithPhoto(row) {
	const name = sanitize(convertHTMLEntitiesInString(row[0]));

	function emptyQsRow(row) {
		let ret = `<span class="qsEmpty">${name}:</span><br/>`;
		ret += `<span class="qsEmpty">"${row[2]}"</span>`;
		return ret;
	}

	// row[1] is the type - empty for no match found
	if (row[1] == 'empty') {
		return emptyQsRow(row);
	}
	let img = '';
	if (typeof row[3] !== 'undefined') {
		if (row[1] === 'user_group' || row[1] === 'group' || row[1] === 'location') {
			img = `<img class="Avatar baseColorBg qsPhoto qsPhotoGroup" src="/images/color-branded-icons/share/group.png"/>`;
			img += `<img class="Avatar baseColorBg qsPhoto qsPhotoGroup qsPhotoGroup-hover" src="/images/color-branded-icons/share/group-hover.png"/>`;
			if (isEnabled('jade')) {
				img = `<span class="qsPhoto qsPhotoGroup"><ba-icon brand="true" name="fab-people-circle-35x35" encore-name="users-regular" encore-size="20"></ba-icon></span>
					<span class="Avatar__iconHover qsPhoto qsPhotoGroup qsPhotoGroup-hover"><ba-icon brand="false" name="fab-people-circle-35x35" encore-name="users-regular" encore-size="20"></ba-icon></span>`;
			}
		} else {
			img = `<img class="Avatar qsPhoto" src="${row[3]}"/>`;
		}
	}
	let ret = `${img}<span class="js-qsPrimaryText" title="${BambooHR.Utils.htmlentities(name)}">${BambooHR.Utils.htmlentities(
		name
	)}</span>`;
	if (typeof row[4] !== 'undefined') {
		ret += `<span class="jt" >${row[4]}</span>`;
	}
	return ret;
}
export function highlightRow(row, searchTerm) {
	let ret = '',
		highlight;
	const words = row.split(' ');
	const searchWords = searchTerm.split(/ +/);
	for (let i = 0; i < words.length; ++i) {
		highlight = false;
		for (let j = 0; j < searchWords.length; ++j) {
			const pos = words[i].toLowerCase().indexOf(searchWords[j]);
			if (pos === 0) {
				ret += `<strong>${words[i].substr(0, searchWords[j].length)}</strong>${words[i].substr(searchWords[j].length)}`;
				highlight = true;
				break;
			} else if (pos == 1 && words[i].substr(0, 1) == '(') {
				ret += `(<strong>${words[i].substr(1, searchWords[j].length)}</strong>${words[i].substr(searchWords[j].length + 1)}`;
				highlight = true;
				break;
			}
		}
		if (!highlight) {
			ret += words[i];
		}
		ret += ' ';
	}
	return ret;
}

// Used to focus the cursor on page load (depricated, not necessarily needed. $.focus() is sufficient)
export function textCursorFocus(jquery_form) {
	jquery_form.find('input:text:visible:enabled:first').focus();
}

/*
Clear default form value script- by JavaScriptKit.com
Featured on JavaScript Kit (http://javascriptkit.com)
Visit javascriptkit.com for 400+ free scripts!
*/

export function clearText(thefield) {
	if (thefield.defaultValue == thefield.value) {
		thefield.value = '';
	}
}

//=======================
// jQuery plugins
//=======================

// $.focused() function to retreive currently focused input
(function () {
	let focusedElement = null;
	$(document)
		.on('focus', ':input, ba-select', function () {
			focusedElement = this;
		})
		.on('blur', ':input, ba-select', function () {
			focusedElement = null;
		});
	$.focused = function () {
		return focusedElement;
	};
})();
(function () {
	$.fn.positionBy = function (byThis, alignment) {
		byThis = $(byThis);
		const fPos = byThis.position();
		let top = 0;
		let left = 0;
		if (fPos.top + this.outerHeight(true) > byThis.offsetParent().height() && fPos.top - this.outerHeight(true) > 0) {
			alignment = alignment.replace('bottom', 'top');
		}
		switch (alignment) {
			case 'topLeft':
				top = fPos.top - this.outerHeight(true) + parseInt(byThis.css('margin-top'));
				left = fPos.left + parseInt(byThis.css('margin-left'));
				break;
			case 'topRight':
				top = fPos.top - this.outerHeight(true) + parseInt(byThis.css('margin-top'));
				left = fPos.left + (this.outerWidth(true) - byThis.outerWidth(false)) * -1 + parseInt(byThis.css('margin-left'));
				break;
			case 'bottomRight':
				top = fPos.top + byThis.outerHeight(true) - parseInt(byThis.css('margin-bottom'));
				left = fPos.left + (this.outerWidth(true) - byThis.outerWidth(false)) * -1 + parseInt(byThis.css('margin-left'));
				break;
			case 'rightCenter':
				top = fPos.top - this.outerHeight(true) / 2 + parseInt(byThis.css('margin-top')) + byThis.outerHeight(true) / 2;
				left = fPos.left + byThis.outerWidth(true) + parseInt(byThis.css('margin-left'));
				break;
			case 'topCenter':
				top = fPos.top - this.outerHeight(true) + parseInt(byThis.css('margin-top'));
				left = fPos.left + parseInt(byThis.css('margin-left')) - this.outerWidth(true) / 2;
				break;
			case 'bottomLeft':
			/* falls through */
			default:
				top = fPos.top + byThis.outerHeight(true) - parseInt(byThis.css('margin-bottom'));
				left = fPos.left + parseInt(byThis.css('margin-left'));
				break;
		}

		this.css('top', `${top}px`).css('left', `${left}px`);
		this.appendTo(byThis.offsetParent());
		return this;
	};
})();

(function () {
	/* Begin datepicker 2 digit year format fixer */
	// NOTE: This is for handling two digit year formats. This will need to be removed when we launch the proposed new
	// in-house datepicker. This will reach out as far as you can make selections in the dropdown for years
	// Example: if year is 2016, and you type 36 in the input, it will default to 2036, but if you put 37, it will
	// default to 1937..., which is why we are migrating away from 2 digit year formats

	// The reason for splitting on the window.HSHQ_DATEPICKER_OPTIONS.yearRange is to follow whatever is set in those options
	$.datepicker.setDefaults({
		shortYearCutoff: HSHQ_DATEPICKER_OPTIONS.yearRange.split(':')[1],
	});
	// Carry on...
	/* End datepicker 2 digit year format fixer */

	$.datepicker._triggerClass = DATEPICKER_JADE_MAP.triggerClasses;
	$.fn.bhrdatepicker = function (options) {
		/**
		 * Our bhrdatepicker plugin stops some functionality that should be available when initializing normal datepickers
		 * The normal API allows you to update an option, or pass in an object of things you want to update
		 * Without the ability to do so, we cannot override things like minDate, etc. By applying the arguments back to
		 * datepicker, we can regain some of the functionality that should exist on the datepickers.
		 */
		const args = Array.prototype.slice.call(arguments);
		if (args.length === 2 && typeof args[0] === 'string') {
			options = args[1];
		}

		this.each(function (index, item) {
			const $this = $(item);

			// we are overriding this to take into account the sticky footer so it pops above instead of below and behind the footer
			$.extend($.datepicker, {
				_checkOffset(inst, offset, isFixed) {
					const dpWidth = inst.dpDiv.outerWidth();
					const dpHeight = inst.dpDiv.outerHeight(true);
					const inputWidth = inst.input ? inst.input.outerWidth() : 0;
					const inputHeight = inst.input ? inst.input.outerHeight() : 0;
					let footerHeight = $('body > footer').height();

					if ($('body > footer').hasClass('staticFooter')) {
						footerHeight -= $('body > footer').offset().top;
					}

					const viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft());
					const viewHeight = document.documentElement.clientHeight - footerHeight + (isFixed ? 0 : $(document).scrollTop());

					offset.left -= this._get(inst, 'isRTL') ? dpWidth - inputWidth : 0;
					offset.left -= isFixed && offset.left == inst.input.offset().left ? $(document).scrollLeft() : 0;
					offset.top -= isFixed && offset.top == inst.input.offset().top + inputHeight ? $(document).scrollTop() : 0;

					// now check if datepicker is showing outside window viewport - move to a better place if so.
					offset.left -= Math.min(
						offset.left,
						offset.left + dpWidth > viewWidth && viewWidth > dpWidth ? Math.abs(offset.left + dpWidth - viewWidth) : 0
					);
					offset.top -= Math.min(
						offset.top,
						offset.top + dpHeight > viewHeight && viewHeight > dpHeight ? Math.abs(dpHeight + inputHeight) : 0
					);

					return offset;
				},
			});

			$this.datepicker(...args);
			function setupChosen(ui) {
				const options = $.extend({}, window.bhrChosenOptions, { disable_search_threshold: 130 });
				ui.dpDiv.find('select').chosen(options);
				ui.dpDiv.css('z-index', getMaxZIndex() + 10); // Set z-index
			}
			$this.datepicker('option', 'beforeShow', function (input, ui) {
				ui.dpDiv.addClass('baseBorderColor');
				//we have to wait until after it's show to replace the dropdowns...
				setTimeout(function () {
					setupChosen(ui);
				}, 1);
				// We can't just override the original function, we have to call anything that was passed also...
				if (options.beforeShow instanceof Function) {
					options.beforeShow(input, ui);
				}
			});
			$this.datepicker('option', 'onChangeMonthYear', function (year, month, ui) {
				setTimeout(function () {
					setupChosen(ui);
				}, 1);
				// We can't just override the original function, we have to call anything that was passed also...
				if (options.onChangeMonthYear instanceof Function) {
					options.onChangeMonthYear(year, month, ui);
				}
			});
			//This sucks, we shouldn't have to poll to make sure this happens, but datepicker is set up without any events to capture.
			setInterval(function () {
				$this.next('button').attr('tabindex', -1).find('img').addClass('branded-icon');
			}, 100);
		});
		return this;
	};
})();

$.valHooks.textarea = {
	get(elem) {
		return elem.value.replace(/\r?\n/g, '\r\n');
	},
};

function lengthInUtf8Bytes(str) {
	// Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
	const m = encodeURIComponent(str).match(/%[89ABab]/g);
	return str.length + (m ? m.length : 0);
}
(function ($) {
	$.fn.limitCount = function (max = $(this).attr('maxlength'), options) {
		const defaults = {
			displaySelector: null,
			countBytes: false,
		};
		const settings = $.extend(true, {}, defaults, options);
		$(this).each(function () {
			const jthis = $(this);
			settings.loadedLength = lengthInUtf8Bytes(jthis.val());

			jthis.data('limitCount-settings', settings);
			let display = $(settings.displaySelector);

			if (display.length === 0) {
				display = $('<div class="limitCount js-limitCount" style="margin-top:0;"></div>').insertAfter(jthis);
			}

			//setting timeouts on the function calls within the events. For some key combinations, the input value
			//is only updated after the events fire.
			jthis
				.focus(function () {
					limitCountNeedsUpdate(jthis, display);
					display.css({ opacity: '1', 'margin-top': '1px' });
				})
				.blur(function () {
					display.css('opacity', '0');
				});

			jthis.on('input', function () {
				setTimeout(function () {
					limitCountNeedsUpdate(jthis, display);
				}, 0);
			});
		});

		function limitCountNeedsUpdate(jthis, display) {
			const options = jthis.data('limitCount-settings');
			let chars = 0;
			if (options.countBytes) {
				chars = lengthInUtf8Bytes(jthis.val());
			} else {
				chars = jthis.val().length;
			}
			updateCount(chars, max, display, jthis, options);
		}

		/**
		 * Update the count for the limitCount (in house) plugin
		 *
		 * @param {int}    chars   The current number of characters in the element
		 * @param {int}    max     The maximum number of characters allowed
		 * @param {object} display The jquery object that is displaying the character count
		 * @param {object} input   The jquery object that is begin counted
		 *
		 * @return void
		 */
		function updateCount(chars, max, display, input, settings) {
			let charsRemaining = parseInt(max - chars);
			if (charsRemaining < 0) {
				const value = input.val();
				let shorterValue = null;
				if (settings.countBytes) {
					//cap at the loaded length, or max, whichever is longer.
					shorterValue = findLongestStringForByteCount(value, chars, Math.max(max, settings.loadedLength));
					charsRemaining = max - lengthInUtf8Bytes(shorterValue);
				} else {
					//it's likely that html5 will enforce the text limit, so we won't get to a negative number, but in case we do...
					shorterValue = value.slice(0, max);
					charsRemaining = max - shorterValue.length;
				}
				input.val(shorterValue);
			}
			display.removeClass('limitCount--warning limitCount--error');
			display.html(charsRemaining);
			if (charsRemaining > 100) {
				display.hide();
			} else {
				display.show();
				if (charsRemaining <= 20 && charsRemaining > 0) {
					display.addClass('limitCount--warning').removeClass('limitCount--error');
				} else if (charsRemaining <= 0) {
					display.addClass('limitCount--error').removeClass('limitCount--warning');
				}
			}
		}

		function findLongestStringForByteCount(value, chars, max) {
			const bytesToCut = chars - max;
			let charsToCut = 1;
			const textArray = Array.from(value);
			while (lengthInUtf8Bytes(textArray.slice(textArray.length - charsToCut, textArray.length).join('')) < bytesToCut) {
				charsToCut++;
			}
			return textArray.slice(0, textArray.length - charsToCut).join('');
		}
	};
})(jQuery);

/**
 * Character counts for textareas with maxlength
 */
$('textarea[maxlength]').each(function () {
	const options = {};
	if ($(this).is('[ba-count-chars]')) {
		options.countBytes = false;
	}
	if ($(this).is('[count-bytes]')) {
		options.countBytes = true;
	}
	$(this).limitCount($(this).attr('maxlength'), options);
});

/**
 * $.fadeHighlight() function to display highlighted background that fades
 * and Keara's first ever jquery plugin.. hooray! ya I know, it was an easy one.
 */
(function () {
	$.fn.fadeHighlight = function (options) {
		const settings = $.extend(
			{
				highlightColor: '#fdffd5',
				backgroundColor: 'transparent',
				duration: 900,
				delay: 1000,
			},
			options
		);

		return this.each(function () {
			const $that = $(this);
			const background = $that.css('background-color');
			$(this)
				.addClass('hightlightFading')
				.css('background-color', settings.highlightColor)
				.delay(settings.delay)
				.animate(
					{
						backgroundColor: background,
					},
					{
						duration: settings.duration,
						complete() {
							$($that).removeClass('hightlightFading');
						},
					}
				);
		});
	};
})();

/*

Copyright (c) 2009 Stefano J. Attardi, http://attardi.org/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/
(function () {
	$.extend({
		insetLabel: new (function () {
			function toggleLabel() {
				const input = $(this);
				setTimeout(function () {
					const def = input.attr('title');
					let val = input.val();

					if (input.is('div[contenteditable=true]')) {
						val = input.text();
					}
					if (!val || val == def) {
						input.prev('span').css('visibility', '');
						if (def) {
							const dummy = $('<label></label>').text(def).css('visibility', 'hidden').appendTo('body');
							input.prev('span').css('margin-left', `${dummy.width() + 3}px`);
							dummy.remove();
						}
					} else {
						input.prev('span').css('visibility', 'hidden');
					}
				}, 0);
			}

			function resetField() {
				const def = $(this).attr('title');
				if (!$(this).val() || $(this).val() == def) {
					$(this).val(def);
					$(this).prev('span').css('visibility', '');
				}
			}

			this.construct = function () {
				this.filter('input, textarea, div[contenteditable=true]').on('keydown', toggleLabel);
				this.filter('input, textarea, div[contenteditable=true]').on('paste', toggleLabel);
				this.filter('select').on('change', toggleLabel);

				this.filter('input, textarea, div[contenteditable=true]').on('focusin', function () {
					$(this).prev('span').css('color', '#a0a0a0');
				});
				this.filter('input, textarea, div[contenteditable=true]').on('focusout', function () {
					$(this).prev('span').css('color', '#a0a0a0');
				});

				this.filter('input, textarea, div[contenteditable=true]').each(function () {
					toggleLabel.call(this);
				});
			};
		})(),
	});

	$.fn.extend({ insetLabel: $.insetLabel.construct });
})();

$(function () {
	$('input.btn.addProcessing').on('click', function () {
		$(this)
			.addClass('disabled processing')
			.wrap("<span class='inputBtnProcessing'></span>")
			.parent('.inputBtnProcessing')
			.prepend("<img src='/images/buttons/button-processing.gif'/>");
	});
});

$(function () {
	//dynamic disable for btnGroup input fields
	$('.btnGroup input.text.dynamicDisable').siblings('.btn').addClass('disabled');
	$('.btnGroup input.text.dynamicDisable')
		.on('keydown', function () {
			$(this).siblings('.btn').removeClass('disabled');
		})
		.on('blur', function () {
			if ($(this).val() === '') {
				$(this).siblings('.btn').addClass('disabled');
			}
		});

	$(document).initializeElements();
});

$(function () {
	$(document).on(
		{
			mouseenter(e) {
				e.preventDefault();
				const jThis = $(this);
				const tt = $('<div class="fancyTT"/>').html(jThis.attr('title')).insertAfter(this).show();
				tt.css({
					'margin-left': (tt.outerWidth(true) / 2 - jThis.outerWidth(true) / 2) * -1,
				});
				jThis.data('ot', this.title);
				jThis.attr('title', '');
			},
			mouseleave() {
				const jThis = $(this);
				$('.fancyTT').remove();
				jThis.attr('title', jThis.data('ot'));
			},
		},
		'.fancyTTHover'
	);
});

window.autosize = autosize;
// Create the plugin:
window.jQuery.fn.autosize = function () {
	return autosize(this);
};

// Function to accept terms of service
export function acceptTerms() {
	$.post('/ajax/terms/accept');
	$('.ba-banner--alert').slideUp('normal');
}

// Function to dismiss terms of service
export function dismissTerms() {
	$.post('/ajax/terms/dismiss');
	$('.ba-banner--alert').slideUp('normal');
}

//JN - plugin to turn a tables tbody to a scrollable area
(function () {
	$.fn.scrollTables = function () {
		const $this = $(this);

		return $this.each(function () {
			$this.addClass('bhrScrollTable');

			const widths = getWidths();
			moveContent(widths);

			$this.children('thead').addClass('fixedHeader');
		});

		function moveContent(widths) {
			const scrollContent = $('.bhrScrollTable tbody').html();
			const tdCount = $('.bhrScrollTable thead th').length;
			const firstTdWidth = $('.bhrScrollTable thead th:first-child').outerWidth() - 3;
			const content = `<tr><td colspan="${tdCount}" class="scrollContent"><div class="scrollBody"><table>${scrollContent}</table></div></td></tr>`;

			$('.bhrScrollTable tbody').html(content);
			$('.bhrScrollTable .scrollBody tr:first-of-type td:not(:last-child)').each(function (i) {
				$(this).css('width', `${widths[i] - parseInt($(this).css('padding-left')) - parseInt($(this).css('padding-right'))}px`);
			});
		}

		function getWidths() {
			const widths = [];
			$('.bhrScrollTable tbody tr:first-of-type td').each(function (i) {
				let width = $(this).outerWidth();
				if (i === 0) {
					width -= 3;
				}
				widths.push(width);
			});

			return widths;
		}
	};
})();
/**
 * inserts the element at the given index in the array
 */
(function () {
	$.fn.insertAt = function (index, element) {
		const lastIndex = this.children().size();
		if (index < 0) {
			index = Math.max(0, lastIndex + 1 + index);
		}
		this.append(element);
		if (index < lastIndex) {
			this.children().eq(index).before(this.children().last());
		}
		return this;
	};
})();
/**
 * Uses the setMessage function to set a fall back error message
 *
 * @returns void
 */
export function errorFallBack() {
	setMessage($.__('An error occurred'), 'error');
}
/**
 * Equivalent to BLocale's getFloatFromString function
 *
 * This function takes a number string in the current locale and converts to a
 * JavaScript readble float to execute in summing, subtracting, etc. with numbers
 *
 * @param {String} str the number to be converted
 *
 * @returns {float} number in the format 123456789.123456789 (notice no commas)
 */
export function getFloatFromStringJS(str) {
	if (window.GLOBAL_THOUSANDS_SEPARATOR !== undefined && window.GLOBAL_THOUSANDS_SEPARATOR !== '') {
		str = str.replaceAll(window.GLOBAL_THOUSANDS_SEPARATOR, '');
	}
	str = str.replace(window.GLOBAL_DECIMAL_CHAR, '.');

	str = str.replace(/[^0-9.-]/g, '');

	// check for trailing decimal or comma
	if (!$.isNumeric(str.substring(-1))) {
		str = str.substring(0, -1);
	}
	return parseFloat(str);
}

/**
 * Equivalent to BLocale's formatNumber function
 *
 * This function takes a float value (1234567.1234567 for example) and converts
 * it back to a formatted number in the current locale.
 *
 * @param {float} num           the float value in the format 123456789.123456789 (notice no commas) to be converted back to the locale format
 * @param {int}   decimalPlaces the number of decimal places to be used (similar to using .toFixed(num) )
 *
 * @returns string the converted locale float
 */
export function formatNumberJS(num, decimalPlaces) {
	return number_format(parseFloat(num), decimalPlaces, window.GLOBAL_DECIMAL_CHAR, window.GLOBAL_THOUSANDS_SEPARATOR);
}

/**
 * JS equivalent function to PHP's number_format
 *
 * Acquired from http://phpjs.org/functions/number_format/
 *
 * @param {float} number       The number to be formatted
 * @param {int} decimals       The number of decimal places to return
 * @param {char} dec_point     The decimal point character (default '.')
 * @param {char} thousands_sep The thousands seperator character (default ',')
 *
 * @returns {String}
 */
export function number_format(number, decimals, dec_point, thousands_sep) {
	//  discuss at: http://phpjs.org/functions/number_format/
	// original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: davook
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Theriault
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// bugfixed by: Michael White (http://getsprink.com)
	// bugfixed by: Benjamin Lupton
	// bugfixed by: Allan Jensen (http://www.winternet.no)
	// bugfixed by: Howard Yeend
	// bugfixed by: Diogo Resende
	// bugfixed by: Rival
	// bugfixed by: Brett Zamir (http://brett-zamir.me)
	//  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	//  revised by: Luke Smith (http://lucassmith.name)
	//    input by: Kheang Hok Chin (http://www.distantia.ca/)
	//    input by: Jay Klehr
	//    input by: Amir Habibi (http://www.residence-mixte.com/)
	//    input by: Amirouche
	// improved by: Jordan Petersen (Bamboo HR, 2018-03-26) linting changes
	//   example 1: number_format(1234.56);
	//   returns 1: '1,235'
	//   example 2: number_format(1234.56, 2, ',', ' ');
	//   returns 2: '1 234,56'
	//   example 3: number_format(1234.5678, 2, '.', '');
	//   returns 3: '1234.57'
	//   example 4: number_format(67, 2, ',', '.');
	//   returns 4: '67,00'
	//   example 5: number_format(1000);
	//   returns 5: '1,000'
	//   example 6: number_format(67.311, 2);
	//   returns 6: '67.31'
	//   example 7: number_format(1000.55, 1);
	//   returns 7: '1,000.6'
	//   example 8: number_format(67000, 5, ',', '.');
	//   returns 8: '67.000,00000'
	//   example 9: number_format(0.9, 0);
	//   returns 9: '1'
	//  example 10: number_format('1.20', 2);
	//  returns 10: '1.20'
	//  example 11: number_format('1.20', 4);
	//  returns 11: '1.2000'
	//  example 12: number_format('1.2000', 3);
	//  returns 12: '1.200'
	//  example 13: number_format('1 000,50', 2, '.', ' ');
	//  returns 13: '100 050.00'
	//  example 14: number_format(1e-8, 8, '.', '');
	//  returns 14: '0.00000001'

	number = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
	const n = isFinite(+number) ? +number : 0;
	const prec = isFinite(+decimals) ? Math.abs(decimals) : 0;
	const sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
	const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
	let s = '';
	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '').length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1).join('0');
	}
	return s.join(dec);

	function toFixedFix(n, prec) {
		const k = Math.pow(10, prec);
		return `${(Math.round(n * k) / k).toFixed(prec)}`;
	}
}

/**
 * Checks if you are on a mobile device.
 * @return {Boolean} True is device is mobile, false if not.
 */
export function isMobile() {
	return (
		window.navigator.userAgent.match(/Android/i) ||
		window.navigator.userAgent.match(/webOS/i) ||
		window.navigator.userAgent.match(/iPhone/i) ||
		window.navigator.userAgent.match(/iPad/i) ||
		window.navigator.userAgent.match(/iPod/i) ||
		window.navigator.userAgent.match(/BlackBerry/i) ||
		window.navigator.userAgent.match(/Windows Phone/i)
	);
}

// Only Register autosize on non-mobile devices (scroll bug associated with autosize.)
// Ben Eliason 03-07-2016
if (!isMobile()) {
	$.registerElementInitializer('textarea.autosize', function () {
		this.autosize();
	});
}

//This is the old way/plugin, used in ATS
$.registerElementInitializer('label.input :input, label.input ba-select', function () {
	this.insetLabel();
});

$.registerElementInitializer('select:visible:not(.chzn-ignore)', function (container) {
	try {
		this.chosen(window.bhrChosenOptions);
		$('.chzn-container input[type="text"]', container).addClass('chzn_selected');
	} catch (e) {
		if (window.Rollbar && window.Rollbar.info) {
			window.Rollbar.info('Chosen being used when not available.');
		}
	}
});

$.registerElementInitializer('[name=countryId]', function () {
	this.trigger('liszt:updated');
	this.trigger('change');
});

$.registerElementInitializer('.calendar-field', function () {
	//make sure the mask plugin has been initialized with our modified masks.
	if (typeof $.mask !== 'undefined') {
		$.mask.definitions.d = $.mask.definitions['9'];
		$.mask.definitions.m = $.mask.definitions['9'];
		$.mask.definitions.y = $.mask.definitions['9'];
		$.mask.definitions.Y = $.mask.definitions['9'];
		$.mask.definitions.M = '[A-Za-zäéû]';
		$.mask.placeholders.d = 'd';
		$.mask.placeholders.m = 'm';
		$.mask.placeholders.y = 'y';
		$.mask.placeholders.Y = 'Y';
		$.mask.placeholders.M = 'M';
	}
});

$.registerElementInitializer('.calendar-field:not([name*=":idx:"])', function () {
	const dateMask = window.GLOBAL_DATE_MASK || 'mm/dd/yyyy';
	const selected = this;

	if (selected.length > 0) {
		selected.each(function () {
			const $this = $(this);
			const datepickerOptions = clone(window.HSHQ_DATEPICKER_OPTIONS);
			const defaultDate = $this.attr('defaultDate');

			if ($this.hasClass('js-validate-todayAndFuture')) {
				datepickerOptions.minDate = 0;
			}

			$this.bhrdatepicker(datepickerOptions).attr('autocomplete', 'off');

			if (typeof $this.inputmask === 'function') {
				$this.inputmask(dateMask).trigger('masked');

				if (!$this.is('[placeholder]')) {
					$this.attr('placeholder', $this.inputmask('getemptymask'));
				}
			}

			if (defaultDate !== '') {
				$this.datepicker('option', 'defaultDate', defaultDate);
			}
		});
	}
});

$.registerElementInitializer('.ssn-field', function () {
	const selected = this;
	if (selected.length > 0) {
		selected
			.inputmask('999-99-9999', { greedy: false, clearIncomplete: true, placeholder: '___-__-____' })
			.attr('autocomplete', 'off');
	}
});

$.registerElementInitializer('.sin-field', function () {
	const selected = this;
	if (selected.length > 0) {
		selected
			.inputmask('999-999-999', { greedy: false, clearIncomplete: true, placeholder: '___-___-___' })
			.attr('autocomplete', 'off');
	}
});

$.registerElementInitializer('.js-validate-field.js-validate-nin', function () {
	const selected = this;
	if (selected.length > 0) {
		selected
			.inputmask('** ** ** ** *', { greedy: false, clearIncomplete: true, placeholder: '__ __ __ __ _' })
			.attr('autocomplete', 'off');
	}
});

$.registerElementInitializer('.js-validate-field.js-validate-national-id', function () {
	const selected = this;
	if (selected.length > 0) {
		selected.inputmask('******[*]{0,10}', { greedy: false, clearIncomplete: true, placeholder: '______' }).attr('autocomplete', 'off');
	}
});

$.registerElementInitializer('.js-validate-field.js-validate-passport-number', function () {
	const selected = this;
	if (selected.length > 0) {
		selected.inputmask('[*]{0,20}', { greedy: false, clearIncomplete: true }).attr('autocomplete', 'disable-auto-complete');
	}
});

$.registerElementInitializer('.insertable-list:not([name*=":idx:"])', function () {
	if ($('insertable-list').insertableList !== undefined) {
		const postback = '/ajax/list_insert.php';
		this.insertableList(postback, $.__('-- Add New --'));
		this.trigger('liszt:updated');
	}
});

$.registerElementInitializer('.cc-expiration-field', function () {
	if (this.length > 0) {
		this.mask('99/99');
	}
});

$.registerElementInitializer('.chzn-container input[type="text"]', function () {
	this.addClass('chzn_selected');
});

// Update chosen dropdowns oninput
$(document).on('input', 'select.chzn-done', function () {
	$(this).trigger('liszt:updated');
});

$('body').on('click', '[tracking-action], [data-trackingaction]', function () {
	const trackingAction = $(this).attr('tracking-action') || $(this).attr('data-trackingaction');
	const getType = function (element) {
		const tagName = element.prop('tagName');
		if (element.hasClass('btn')) {
			return 'button';
		}
		switch (tagName) {
			case 'A':
				return 'link';
			case 'BUTTON':
			case 'INPUT':
				return 'button';
		}
		return tagName.toLowerCase();
	};
	const type = getType($(this));
	const { trackingProps, category } = this.dataset;
	const props = trackingProps ? JSON.parse(trackingProps) : {};
	const properties = { type, ...props, category };
	trackAction(trackingAction, properties);
});

/**
 * trackAction - send tracking data to google analytics
 *
 * @param  {string} trackingAction  event name value. e.g. ExportOrgChart_Download
 * @param  {object} properties = {} extra tracking properties to be passed on
 * @param  {string} eventType       event types like 'click', 'submit', 'change'. Defaults to 'click'
 */
export function trackAction(trackingAction, properties = {}, eventType = 'click') {
	BambooHR.Utils.eventTrack(properties.category || properties.type, eventType, trackingAction, null);
}

/**
 * Register the rate change widget for the compensation pay rate field
 *
 * (Was previously in history_table.js)
 *
 * @returns {void}
 */
export function registerRateChange() {
	let prevRate = 0,
		prevPercent = 0,
		amt,
		rateChange;
	$('.js-rate, .js-ratePercent').on('blur', function () {
		const thousands = typeof window.GLOBAL_THOUSANDS_SEPARATOR === 'undefined' ? ',' : window.GLOBAL_THOUSANDS_SEPARATOR;
		const decimal = typeof window.GLOBAL_DECIMAL_CHAR === 'undefined' ? '.' : window.GLOBAL_DECIMAL_CHAR;
		// replace anything that is not a number or a decimal or comma
		// this will get rid of any currency symbols
		// then replace the thousands separator
		const regex = new RegExp(`\\${thousands}`, 'g');
		const $originalRate = $('.js-originalRate');
		let prevAmt = null;
		if ($originalRate.length) {
			prevAmt = parseFloat(
				$originalRate
					.val()
					.replace(/[^-?0-9\.\,]+/g, '')
					.replace(regex, '')
					.replace(',', '.')
			);
		}

		if ($('.js-rate').val() == prevRate && $('.js-ratePercent').val() == prevPercent) {
			// no changes detected so return.
			// This prevents us from re evaluating
			// the percent and lowering the pay rate on accident
			return;
		}

		if (!prevAmt) {
			$('.js-ratePercent').attr('disabled', 'disabled');
			return;
		}

		if ($(this).hasClass('currency-field')) {
			// we are blurring on the currency - update the percent
			amt = parseFloat(
				$(this)
					.val()
					.replace(/[^0-9\.\,]+/g, '')
					.replace(regex, '')
					.replace(',', '.')
			);
			rateChange = (((amt - prevAmt) / prevAmt) * 100).toFixed(2).toString();
			let change = parseFloat(rateChange);
			change = isNaN(change) ? '' : change; //Make sure to set the percent field to an empty string if the number returned is NaN
			$('.js-ratePercent').val(change);
			$('.js-ratePercent').siblings('label').hide();
		} else {
			// we are blurring on the percent - update the currency
			rateChange = $(this)
				.val()
				.replace(/[^0-9\.-]+/g, '');
			amt = (rateChange * prevAmt) / 100 + prevAmt;
			amt.toString().replace('.', decimal); //If the decimal character is a "," (comma) place it back in before sending to the format currency method
			$('.js-rate')
				.val(amt)
				.formatCurrency({
					thousands,
					decimal,
					symbol: $('.js-rate').data('cursymbol'),
					oldSymbol: $('.js-rate').data('oldcursymbol'),
				});
		}
		prevRate = $('.js-rate').val();
		prevPercent = $('.js-ratePercent').val();
	});
}
export function toggleSwitch(el) {
	el = $(el);
	if (el.hasClass('time-off-inactive')) {
		el.addClass('time-off-active').removeClass('time-off-inactive');
		el.attr('title', $.__('Click to turn off'));
		el.siblings('input').val('on');
		el.closest('.item__aLaCarte').find('input[name*="aLaCarteSwitch"]').val('on');
	} else {
		el.addClass('time-off-inactive').removeClass('time-off-active');
		el.attr('title', $.__('Click to turn on'));
		el.siblings('input').val('off');
		el.closest('.item__aLaCarte').find('input[name*="aLaCarteSwitch"]').val('off');
	}
}
export function clone(obj) {
	if (obj === null || typeof obj !== 'object') {
		return obj;
	}
	const copy = obj.constructor();
	for (const attr in obj) {
		if (obj.hasOwnProperty(attr)) {
			copy[attr] = obj[attr];
		}
	}
	return copy;
}

/**
 * JavaScript version of PHP's empty
 *
 * @param {mixed} variable A variable to check for 'empty'
 *
 * @returns {Boolean}
 */
export function empty(variable) {
	return (
		typeof variable === 'undefined' ||
		variable === null ||
		variable === false ||
		variable === '' ||
		variable === 0 ||
		variable === 0.0 ||
		variable === '0'
	);
}

$('img').error(function () {
	avatarFallback(this);
});
